import { render, staticRenderFns } from "./platticketrecord-add-or-update.vue?vue&type=template&id=23254173&"
import script from "./platticketrecord-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platticketrecord-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports